/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadWarningDetails
 */
export interface LeadWarningDetails {
    /**
     * 
     * @type {string}
     * @memberof LeadWarningDetails
     */
    limit_name?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadWarningDetails
     */
    limit_value?: number;
    /**
     * 
     * @type {number}
     * @memberof LeadWarningDetails
     */
    actual_value?: number;
}

/**
 * Check if a given object implements the LeadWarningDetails interface.
 */
export function instanceOfLeadWarningDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadWarningDetailsFromJSON(json: any): LeadWarningDetails {
    return LeadWarningDetailsFromJSONTyped(json, false);
}

export function LeadWarningDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWarningDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit_name': !exists(json, 'limit_name') ? undefined : json['limit_name'],
        'limit_value': !exists(json, 'limit_value') ? undefined : json['limit_value'],
        'actual_value': !exists(json, 'actual_value') ? undefined : json['actual_value'],
    };
}

export function LeadWarningDetailsToJSON(value?: LeadWarningDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit_name': value.limit_name,
        'limit_value': value.limit_value,
        'actual_value': value.actual_value,
    };
}

